import React, { useState } from 'react';
import { planTrabajoIncidenciasService } from '../../../services/planTrabajoService';

const TIPOS = planTrabajoIncidenciasService?.TIPOS || [
  { value: 'FALTA_MERCANCIA', label: 'Falta mercancía' },
  { value: 'PIEZA_DEFECTUOSA', label: 'Pieza defectuosa' },
  { value: 'CLIENTE_CAMBIA', label: 'Cliente cambia condiciones' },
  { value: 'NO_TERMINA_HOY', label: 'No se termina hoy' },
  { value: 'OTRO', label: 'Otro' },
];

const IncidenciaModal = ({ isOpen, trabajo, onClose, onSaved }) => {
  const [tipo, setTipo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen || !trabajo) return null;

  const handleSave = async () => {
    if (!tipo) { setError('Selecciona un tipo de incidencia'); return; }
    setSaving(true);
    setError(null);
    try {
      await planTrabajoIncidenciasService?.create({
        trabajoId: trabajo?.id,
        tipo,
        descripcion: descripcion?.trim() || null,
      });
      setTipo('');
      setDescripcion('');
      onSaved?.();
      onClose?.();
    } catch (err) {
      console.error('[IncidenciaModal.handleSave]', err);
      setError(err?.message || 'Error al guardar incidencia');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.75)' }}>
      <div className="w-full max-w-sm rounded-2xl border border-white/10 overflow-hidden" style={{ background: '#111111' }}>
        {/* Header */}
        <div className="px-5 py-4 border-b border-white/8 flex items-center justify-between">
          <div>
            <div className="text-white font-oranienbaum font-bold text-base">! Incidencia</div>
            <div className="text-white/40 text-xs font-oranienbaum mt-0.5">{trabajo?.cliente?.nombre}</div>
          </div>
          <button onClick={onClose} className="text-white/30 hover:text-white/60 transition-colors text-xl leading-none">×</button>
        </div>

        {/* Tipos rápidos */}
        <div className="p-4 space-y-2">
          {TIPOS?.map(t => (
            <button
              key={t?.value}
              onClick={() => setTipo(t?.value)}
              className={`w-full text-left px-4 py-3 rounded-xl border transition-all font-oranienbaum text-sm ${
                tipo === t?.value
                  ? 'border-red-500/50 bg-red-500/15 text-red-300' :'border-white/8 bg-white/3 text-white/70 hover:border-white/20 hover:bg-white/6'
              }`}
            >
              {t?.label}
            </button>
          ))}

          {/* Descripción opcional */}
          {tipo === 'OTRO' && (
            <textarea
              value={descripcion}
              onChange={e => setDescripcion(e?.target?.value)}
              placeholder="Describe la incidencia..."
              rows={3}
              className="w-full mt-2 bg-[#1A1A1A] border border-white/10 text-white/80 text-sm rounded-xl px-3 py-2.5 font-oranienbaum placeholder-white/25 focus:outline-none focus:border-red-500/30 resize-none"
            />
          )}

          {error && (
            <div className="text-red-400 text-xs font-oranienbaum px-1">{error}</div>
          )}
        </div>

        {/* Actions */}
        <div className="px-4 pb-4 flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl border border-white/10 text-white/50 font-oranienbaum text-sm hover:border-white/20 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            disabled={saving || !tipo}
            className="flex-1 py-3 rounded-xl bg-red-500/80 text-white font-oranienbaum font-bold text-sm hover:bg-red-500 transition-colors disabled:opacity-40"
          >
            {saving ? 'Guardando...' : 'Registrar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncidenciaModal;
